import {
  faInstagram,
  faFacebook,
  faFacebookF,
  faLinkedin,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

import createFaIcon from './createFaIcon';

export const InstagramIcon = createFaIcon(faInstagram);
export const FacebookIcon = createFaIcon(faFacebook);
export const FacebookFIcon = createFaIcon(faFacebookF);
export const LinkedinIcon = createFaIcon(faLinkedin);
export const LinkedinInIcon = createFaIcon(faLinkedinIn);
